var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-component',{attrs:{"fields":_vm.fields,"items":_vm.items,"paginate":false,"showBaseCount":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }